import React from "react";
import { Dialog as KendoDialog } from "@progress/kendo-react-dialogs";
import CircularProgress from '@mui/material/CircularProgress';

const Loading = (props) => {
  return (
    <KendoDialog>
      <CircularProgress />
    </KendoDialog>
  )
}

const styles = {
  dialog: {
    backgroundColor: 'transparent',
    boxShadow: 'none'
  }
}

export default Loading;